import { useState } from 'react';

export default function useForceUpdate() {
    const [, setValue] = useState(true);
    return () => setValue((val) => !val);
}
